import { Link, useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { getRelated, getWorkById, typeLabel, works } from '@/mocks/catalog';
import WorkHero from '@/pages/detail/components/WorkHero';
import WorkInfoPanel from '@/pages/detail/components/WorkInfoPanel';
import RelatedWorks from '@/pages/detail/components/RelatedWorks';

export default function DetailPage() {
  const { id } = useParams<{ id: string }>();
  const work = id ? getWorkById(id) : undefined;

  useSeo({
    title: work ? `${work.title} - 详情 - 91大神影视平台` : '作品不存在 - 91大神影视平台',
    description: work
      ? `${work.title}（${work.year}）${typeLabel[work.type]}，${work.genres.join('、')}题材，${work.region}出品，导演${work.director}。${work.synopsis.slice(0, 70)}`
      : '该影视内容暂时不可用，返回首页浏览更多电影、剧集与综艺推荐。',
    keywords: work
      ? `91大神, ${work.title}, ${work.genres.join(',')}, ${typeLabel[work.type]}详情, ${work.year}`
      : '91大神, 影视平台',
    canonicalPath: `/detail/${id || ''}`,
    image: work?.poster,
    type: 'article',
  });

  if (!work) {
    return (
      <SiteLayout>
        <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-center px-4 py-24 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-film-line text-2xl"></i>
          </span>
          <h1 className="mt-5 font-display text-xl font-bold text-foreground-950">该影视内容暂时不可用</h1>
          <p className="mt-2 max-w-md text-sm text-foreground-500">
            可能作品已经下架或链接有误。你可以返回首页浏览最新的电影、剧集与综艺推荐。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              浏览电影频道
            </Link>
          </div>
        </div>
      </SiteLayout>
    );
  }

  const related = getRelated(work, 5);
  const fallback = works.filter((w) => w.type === work.type);

  return (
    <SiteLayout>
      <WorkHero work={work} />
      <div className="mx-auto w-full max-w-[1400px] px-4 py-8 md:px-8">
        <WorkInfoPanel work={work} />
        <RelatedWorks currentType={work.type} related={related} fallback={fallback} />
      </div>
    </SiteLayout>
  );
}